export default __webpack_public_path__ + "static/media/ticket.3f93b285.svg";